<!-- 加入队伍 -->
<template>
  <div>
    <!-- 加入队伍触发器 -->
    <button
      :class="$style['join-trigger']"
      style="position: absolute; top: 1.65rem; right: 1.18rem"
      @click="showJoinTeam"
    />

    <!-- 加入队伍弹窗 -->
    <popup-frame ref="join-team" size="mini">
      <h2 style="margin-bottom: 0.4rem; font-size: 0.5rem; font-family: 'Source Han Serif SC Bold'">
        入队邀请
      </h2>
      <form autocomplete="off" @submit.prevent="handleJoinTeam">
        <div :class="$style.field">
          <input v-model="inviteCode" type="tel" :maxlength="7" placeholder="请填写入队邀请码" />
        </div>
        <button :class="$style['join-submit']" />
      </form>
      <p style="width: 5.6rem; margin-top: 0.2rem; font-size: 0.2rem; text-align: left">
        <em>*邀请码为一串数字，请正确填写哦~</em>
      </p>
    </popup-frame>

    <!-- 加入确认弹窗 -->
    <popup-frame ref="join-confirm" size="mini">
      <p style="font-size: 0.32rem; font-family: 'Source Han Serif SC Bold'; line-height: 1.8">
        请问团长是否要加入
        <em>【{{ teamName }}】</em>
        <br />这支队伍呢？
      </p>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.8rem;
          margin: 0.4rem 0;
        "
      >
        <!-- 确认加入 -->
        <button :class="$style['join-confirm']" @click="onConfirmJoin" />
        <!-- 取消加入 -->
        <button :class="$style['join-cancel']" @click="onCancelJoin" />
      </div>
      <p style="font-size: 0.2rem">
        <em>*加入队伍即可获得{{ createTeamRewardName }}！</em>
      </p>
    </popup-frame>

    <!-- 加入失败弹窗 -->
    <popup-frame ref="join-fail" size="mini">
      <h2
        style="margin-bottom: 0.3rem; font-size: 0.45rem; font-family: 'Source Han Serif SC Bold'"
      >
        加入队伍失败！
      </h2>
      <p style="font-size: 0.24rem; line-height: 1.8; padding: 0 0.4rem">{{ errorMsg }}</p>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.8rem;
          margin: 0.3rem 0;
        "
      >
        <!-- 创建队伍 -->
        <button :class="$style['join-create']" @click="onCreateTeam" />
        <!-- 加入其它队伍 -->
        <button :class="$style['join-other']" @click="onJoinOther" />
      </div>
      <p style="font-size: 0.2rem">
        <em>*入队即可获得{{ createTeamRewardName }}！</em>
      </p>
    </popup-frame>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PopupFrame } from '@/components/widgets'
import { fetchTeamInfoByInviteCode, joinTeam } from '@/api'
import { getQueryString } from '@/utils'

export default {
  name: 'JoinTeam',
  components: {
    PopupFrame
  },
  data() {
    return {
      // 邀请码
      inviteCode: '',
      // 队伍名称
      teamName: '',
      // 错误信息
      errorMsg: ''
    }
  },
  computed: {
    ...mapGetters(['isBindRole', 'createTeamReward']),
    createTeamRewardName() {
      return this.createTeamReward.map(item => item.name).join('、')
    }
  },
  methods: {
    // 打开加入队伍弹窗
    showJoinTeam() {
      if (!this.isBindRole) {
        this.$emit('login')
        return
      }

      // 重置邀请码
      this.inviteCode = getQueryString('code') || ''

      this.$refs['join-team'].show()
    },
    // 提交入队邀请码
    async handleJoinTeam() {
      if (!this.inviteCode) {
        this.$toast('请填写入队邀请码')
        return
      }
      // 验证7位数字的邀请码有效性
      if (!/^[0-9]{7}$/.test(this.inviteCode)) {
        this.$toast('请填写有效的入队邀请码')
        return
      }
      // 关闭弹窗
      this.$refs['join-team'].hide()

      // 根据邀请码获取队伍信息
      const { code, data = {} } = await fetchTeamInfoByInviteCode(this.inviteCode)
      if (code === 0 && data.leader_info) {
        this.teamName = data.leader_info.team_name || ''
        this.$refs['join-confirm'].show()
      }
    },
    // 确认加入
    async onConfirmJoin() {
      const { code, msg, data } = await joinTeam(this.inviteCode)
      this.$refs['join-confirm'].hide()
      if (code === 0) {
        this.$emit('join-success', data)
      } else if (code === 7004) {
        this.errorMsg = msg
        this.$refs['join-fail'].show()
      } else {
        this.$toast(msg)
      }
    },
    // 取消加入
    onCancelJoin() {
      this.$refs['join-confirm'].hide()
    },
    // 创建队伍
    onCreateTeam() {
      this.$refs['join-fail'].hide()
      this.$emit('create-team')
    },
    // 加入其它队伍
    onJoinOther() {
      this.$refs['join-fail'].hide()
      this.showJoinTeam()
    }
  }
}
</script>

<style lang="less" module>
.join-trigger {
  .size(1.36rem, 0.46rem);
  .background-fill('./images/join-trigger.png');
}

.field {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.3rem;

  label {
    font-family: 'Source Han Serif SC Bold';
    font-size: 0.28rem;
  }

  input {
    .size(6.12rem, 0.95rem);
    .background-fill('./images/join-input.png');

    border: 0;
    text-align: center;
    color: #c43137;

    &::placeholder {
      color: fade(#c43137, 50%);
    }
  }
}

.join-submit {
  .size(1.95rem, 0.66rem);
  .background-fill('./images/join-submit.png');
}

.join-confirm {
  .size(1.95rem, 0.66rem);
  .background-fill('./images/join-confirm.png');
}

.join-cancel {
  .size(1.95rem, 0.66rem);
  .background-fill('./images/join-cancel.png');
}

.join-create {
  .size(1.95rem, 0.66rem);
  .background-fill('./images/join-create.png');
}

.join-other {
  .size(2.56rem, 0.66rem);
  .background-fill('./images/join-other.png');
}
</style>
